import React from 'react';
import ReportesPowerCV from './controladorVista/reportesPowerCV';
import { IEstadoAPropsReportesPowerCV } from './interfaces';

const ReportesPowerBI: React.FunctionComponent<IEstadoAPropsReportesPowerCV> = ({nombreReporte, filtro,segundoFiltro}) => <ReportesPowerCV nombreReporte={nombreReporte} filtro={filtro} segundoFiltro={segundoFiltro}/>;

export default ReportesPowerBI;
